import adminAxios from "@/shared/api/adminAxiosInstance";

export const login = (credentials) => {
    return adminAxios.post("/admin/auth/login", credentials);
};

export const refreshToken = (refreshToken) => {
    return adminAxios.post("/admin/auth/refresh", { refreshToken });
};

export const logout = (refreshToken) => {
    return adminAxios.delete("/admin/auth/logout", {
        data: { refreshToken }
    });
};